export default __webpack_public_path__ + "bundle.min.css";